import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useAdminSetup } from './useAdminSetup';

export function useRestaurantId() {
  const { user } = useAuth();
  const { restaurantId: adminRestaurantId, isLoading: adminLoading, loadAdminSetup } = useAdminSetup();
  const [restaurantId, setRestaurantId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!user) {
      setRestaurantId(null);
      setIsLoading(false);
      return;
    }

    // Usar el restaurantId del hook useAdminSetup para evitar consultas duplicadas
    if (!adminLoading) {
      console.log('🏪 Usando restaurantId del useAdminSetup:', adminRestaurantId);
      setRestaurantId(adminRestaurantId || null);
      setIsLoading(false);
      setError(null);
    } else {
      setIsLoading(true);
    }
  }, [user, adminRestaurantId, adminLoading]);

  // Función para cargar datos bajo demanda
  const loadRestaurantId = async () => {
    if (!user) return;
    
    setIsLoading(true);
    setError(null);
    
    try {
      await loadAdminSetup();
    } catch (error) {
      setError(error instanceof Error ? error.message : 'Error desconocido');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    restaurantId,
    isLoading,
    error,
    loadRestaurantId, // Exponer función para carga manual
  };
} 